module.exports = __webpack_public_path__ + "img/geod_9.c7ec26cc.jpg";